require("../customiseControls");
import path from "path";

const customControls = () => ({
  settings: {
    borderColor: "#50E6FF",
    cornerSize: 25,
    cornerShape: "circle",
    cornerBackgroundColor: "#50e6ff17",
    cornerPadding: 5,
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
  tl: {
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
  tr: {
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
  bl: {
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
  br: {
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
  mb: {
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
  mt: {
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
  mr: {
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
  ml: {
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
  mtr: {
    icon: path.resolve(`${window.basePath}/images/custom-control-handler.svg`),
  },
});

export default customControls;
